angular.module('shared.camera', [
    'shared.camera.CameraPreviewController',
    'shared.camera.PhotoDocumentsController'
]);